export const perPageOpts = [10, 25, 50];
export const defaultPerPage = perPageOpts[0];
